import React from "react";

export default function NonIdealState({ text, subtext }) {
  return (
    <div className="non-ideal-state">
      <span className="emote">\(o_o)/</span>
      <span className="text white">{text}</span>
      {subtext && <span className="subtext white">{subtext}</span>}
    </div>
  );
}
